/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ApplicationServiceBase", ["EventListenerNativeClass"], function (context, cls) {
  /**
   * Base class of application scoped services
   * @class ApplicationServiceBase
   * @memberOf classes
   * //@extends classes.EventListenerNativeClass
   */
  class ApplicationServiceBase extends cls.EventListenerNativeClass /** @lends classes.ApplicationServiceBase.prototype */ {
    /**
     *
     * @param {classes.VMApplication} app owner
     */
    constructor(app) {
      super(app);
      this._application = app;
      this._destroyed = false;
    }

    /**
     * frees memory hooks of this service (typically when application is destroyed)
     */
    destroy() {
      this._application = null;
    }
    /**
     * Get owning application
     * @publicdoc
     * @return {classes.VMApplication} the owning application
     */
    getApplication() {
      return this._application;
    }
  }
  cls.ApplicationServiceBase = ApplicationServiceBase;
});
